module.exports = __webpack_public_path__ + "img/icon-comfy.890155c0.svg";